<template>
  <el-dialog
    :visible.sync="show"
    :title="'账户充值'"
    @close="close"
    width="500px"
    append-to-body
  >
    <div class="user_account">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="充值积分" name="point">
          <el-form label-width="120px" size="mini">
            <el-form-item label="本站积分">{{ formData.point }}</el-form-item>
            <el-form-item label="联盟积分">
              {{
                formData.alliance.alliance == 1
                  ? formData.alliance.point
                  : "暂未开启联盟"
              }}
            </el-form-item>
            <el-form-item label="变化">
              <el-radio-group v-model="changeType">
                <el-radio :label="1">增加</el-radio>
                <el-radio :label="2">减少</el-radio>
                <el-radio :label="3">最终积分</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="充值数目">
              <el-input class="input_box" v-model="num"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                class="input_box"
                type="textarea"
                v-model="explain1"
                rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" v-if="sms_stats.open_sms_point == 1">
              <el-input class="input_box" v-model="code_num">
                <template slot="append">
                  <el-link
                    :disabled="btn_status"
                    @click="getCode"
                    type="primary"
                    >{{ code_text }}</el-link
                  >
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="充值余额" name="balance">
          <el-form label-width="120px" size="mini">
            <el-form-item label="当前余额">{{ formData.balance }}</el-form-item>
            <el-form-item label="变化">
              <el-radio-group v-model="changeType">
                <el-radio :label="1">增加</el-radio>
                <el-radio :label="2">减少</el-radio>
                <el-radio :label="3">最终余额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="充值数目">
              <el-input class="input_box" v-model="num"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                class="input_box"
                type="textarea"
                v-model="explain1"
                rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" v-if="sms_stats.open_sms_balance == 1">
              <el-input class="input_box" v-model="code_num">
                <template slot="append">
                  <el-link
                    :disabled="btn_status"
                    @click="getCode"
                    type="primary"
                    >{{ code_text }}</el-link
                  >
                </template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="备注">
              <el-input class="input_box" type="textarea" v-model="explain1" rows="2"></el-input>
            </el-form-item> -->
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          v-for="item in typeCardList"
          :key="item.id"
          :label="item.name + '(加油卡)'"
          :name="String(item.id)"
        >
          <el-form label-width="120px" size="mini">
            <!-- <el-form-item label="当前余额">{{ item.balance }}</el-form-item> -->
            <el-form-item label="变化">
              <el-radio-group v-model="changeType">
                <el-radio :label="1">增加</el-radio>
                <el-radio :label="2">减少</el-radio>
                <el-radio :label="3">最终余额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="充值数目">
              <el-input class="input_box" v-model="num"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                class="input_box"
                type="textarea"
                v-model="explain1"
                rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" v-if="sms_stats.open_sms_balance == 1">
              <el-input class="input_box" v-model="code_num">
                <template slot="append">
                  <el-link
                    :disabled="btn_status"
                    @click="getCode"
                    type="primary"
                    >{{ code_text }}</el-link
                  >
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane
          v-for="item in teamCardList"
          :key="item.id"
          :label="item.name + '(车队卡)'"
          :name="String(item.id)"
        >
          <el-form label-width="120px" size="mini">
            <el-form-item label="当前余额">{{ item.balance }}</el-form-item>
            <el-form-item label="变化">
              <el-radio-group v-model="changeType">
                <el-radio :label="1">增加</el-radio>
                <el-radio :label="2">减少</el-radio>
                <el-radio :label="3">最终余额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="充值数目">
              <el-input class="input_box" v-model="num"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                class="input_box"
                type="textarea"
                v-model="explain1"
                rows="2"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" v-if="sms_stats.open_sms_balance == 1">
              <el-input class="input_box" v-model="code_num">
                <template slot="append">
                  <el-link
                    :disabled="btn_status"
                    @click="getCode"
                    type="primary"
                    >{{ code_text }}</el-link
                  >
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div class="button_line">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="close">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { SendAdminCode } from "@/api/set";
import { vipAccountEdit, vipUserDetail } from "@/api/vip";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    showAccount: {
      type: Boolean,
      default: false
    },
    accountData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    tabs: {
      type: String,
      default: "point"
    }
  },
  watch: {
    showAccount(val) {
      this.show = val;
      if (val) {
        console.log("监听数据", this.accountData);
        this.formData = Object.assign({}, this.accountData);
        this.getCardData();
        this.activeName = this.tabs;
        this.cardType = this.tabs == "point" ? "2" : "1";
      }
    }
  },
  data() {
    return {
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      show: false,
      sms_stats: {}, // 短信状态
      activeName: "point",
      formData: {
        alliance: {
          point: ""
        }
      }, //表单信息
      loading: false,
      overLoading: false, //加载完毕
      changeType: "", //变化类型
      num: "", //数目
      explain1: "", // 备注
      typeCardList: [], // 加油卡信息
      teamCardList: [], //车队卡信息
      cardType: "" //充值类型 1.余额 2.积分 3.加油卡 4.车队卡
    };
  },
  async mounted() {
    this.sms_stats = await this.get_prosms_ob();
    console.log(this.sms_stats);
  },
  methods: {
    getCardData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: this.formData.card_id
      };
      vipUserDetail(data).then(res => {
        if (res.code == 200) {
          // if(this.app_id != '432'){
          this.typeCardList = res.data.card_info;
          this.teamCardList = res.data.team_card_info;
          // }
        }
      });
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    save() {
      var data = {
        app_id: this.app_id,
        uid: this.formData.uid,
        type: this.cardType,
        operate_type: this.changeType,
        num: this.num,
        verification_code: this.code_num,
        remark: this.explain1
      };
      if (data.type == "3" || data.type == "4") {
        data.type_card_id = this.activeName;
        console.log(data);
      }
      vipAccountEdit(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功"
          });
          this.$emit("refresh");
          this.$emit("close");
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    close() {
      this.num = "";
      this.code_num = "";
      clearTimeout(this.timer);
      this.$emit("close");
    },
    handleClick(item) {
      this.num = "";
      this.code_num = "";
      if (Number(item.index) > this.typeCardList.length + 1) {
        this.cardType = "4";
      } else if (Number(item.index) > 1) {
        this.cardType = "3";
      } else {
        this.cardType = item.index == "0" ? "2" : "1";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.user_account {
  overflow: auto;
  max-height: 700px;
  .input_box {
    width: 300px;
  }
  .button_line {
    margin-top: 20px;
    text-align: center;
  }
}
.get-code {
  cursor: pointer;
}
</style>
